module.exports = __webpack_public_path__ + "media/400_KBSAT30_2022_SERFIntro.81bc4130.mp4";